import React, { Component } from 'react'
import '../styles/SiteDetails.css'
import APIGenericRequest from '../api/APIGenericRequest'
import APISiteRequest from '../api/APISiteRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import OrgFooter from '../widgets/OrgFooter'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import DropdownWidget from '../widgets/DropdownWidget'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import InputSearchWidget from '../widgets/InputSearchWidget'

class SiteWorkingGroup extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: props.siteId,
			swgItemObj: {},
			swgKeyTracer: 0,
			listItems: [],
			members: {},
			addMembers: {},
			deleteMembers: {},
			disabled: props.disabled
		}
		this.setScrollable = this.setScrollable.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.setSWG = this.setSWG.bind(this)
		this.getAllSiteWorkingGroupsBySiteId = this.getAllSiteWorkingGroupsBySiteId.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const members = []
		const addMembers = []
		var showWarningMessage
		Object.values(this.state.members).forEach((v) => {
			// if(this.state.regNumbers.includes(v.registration_no)) {
			// 	console.log('onsubmit 3')
			// 	showWarningMessage = true
			// 	this.setState({
			// 		showWarningMessage: showWarningMessage,
			// 		aMessage: "Farmer ID number " + v.registration_no + " duplicate entry."
			// 	})
			// }
			// else {
				if(v.member_id != null) {
					members.push(v)
				}
				else {
					addMembers.push(v)
				}
			// }
		})
		const deleteMembers = []
		Object.values(this.state.deleteMembers).forEach((v) => {
			deleteMembers.push(v)
		})
		if(members.length > 0 || deleteMembers.length > 0) {
			var data = {
				siteWorkingGroup: members,
				add: addMembers,
				delete: deleteMembers
			}
		}
		else {
			data = {siteWorkingGroup: addMembers}
		}
		if(data.siteWorkingGroup.length == 0 && data.add == null && data.delete == null) {
			this.setState({
				showInfoMessage: true,
				aMessage: "No data update.",
				showActivityIndicator: false
			})
			return
		}
		if(data.add == null && data.delete == null && members.length < 1) {
			const apiReq = APISiteRequest.addSiteWorkingGroupBySiteId(this.state.accessToken, data, this.state.siteId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description,
						showActivityIndicator: false
					})
					this.getAllSiteWorkingGroupsBySiteId()
					return
				}
				let showInfoMessage = true
				if(showWarningMessage == true) {
					showInfoMessage = false
				}
				this.setState({
					showInfoMessage: showInfoMessage,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false,
					members: {}
				})
				this.getAllSiteWorkingGroupsBySiteId()
			})
		}
		else {
			const apiReq = APISiteRequest.editSiteWorkingGroupBySiteId(this.state.accessToken, data, this.state.siteId)
			apiReq.then((response) => {
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					this.getAllSiteWorkingGroupsBySiteId()
					return
				}
				let showInfoMessage = true
				if(showWarningMessage == true) {
					showInfoMessage = false
				}
				this.setState({
					showInfoMessage: showInfoMessage,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false,
					members: {}
				})
			})
		}
	}

	componentDidMount() {
		this.getAllSiteWorkingGroupsBySiteId()
		window.addEventListener('resize', this.onResize.bind(this))
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize.bind(this))
	}

	onResize() {
		this.setScrollable()
	}

	getAllSiteWorkingGroupsBySiteId() {
		this.setState({showActivityIndicator: true})
		const obi = APISiteRequest.getAllSiteWorkingGroupsBySiteId(this.state.accessToken, this.state.siteId)
		obi.then((response) => {
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			this.setSWG(response.results)
			this.setScrollable()
		})
	}

	setSWG(swgs) {
		const members = []
		const regNumbers = []
		const swgItemObj = {}
		if(swgs != null) {
			for(const v of swgs) {
				const swgKey = "swg-" + this.state.swgKeyTracer
				swgItemObj[swgKey] = <ListItem data={v} handler={this.eventHandler}
					disabled={this.state.disabled}  key={swgKey} id={swgKey} />
				this.state.swgKeyTracer++
				if(v.registration_no != null) {
					regNumbers.push(v.registration_no)
				}
			}
			const swgKey = "swg-" + this.state.swgKeyTracer
			swgItemObj[swgKey] = <ListItem handler={this.eventHandler}
				disabled={this.state.disabled} key={swgKey} id={swgKey} />
			this.state.swgKeyTracer++
			Object.keys(swgItemObj).forEach((k => {
				members.push(swgItemObj[k])
			}))
		}
		else {
			const swgKey = "swg-" + this.state.swgKeyTracer
			swgItemObj[swgKey] = <ListItem handler={this.eventHandler} key={swgKey} id={swgKey} />
			this.state.swgKeyTracer++
			members.push(swgItemObj[swgKey])
		}
		this.setState({
			listItems: members,
			regNumbers: regNumbers,
			swgItemObj: swgItemObj,
			showActivityIndicator: false
		})
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "member":
				this.state.members[compId] = value
				break
			case "add":
				this.state.members[compId] = value
				const added = []
				const swgKey = "swg-" + this.state.swgKeyTracer
				this.state.swgItemObj[swgKey] = <ListItem handler={this.eventHandler} key={swgKey} id={swgKey} />
				this.state.swgKeyTracer++
				this.state.listItems.push(this.state.swgItemObj[swgKey])
				Object.keys(this.state.swgItemObj).forEach((k => {
					added.push(this.state.swgItemObj[k])
				}))
				this.setState({listItems: added})
				break
			case "delete":
				this.state.deleteMembers[compId] = value
				delete this.state.swgItemObj[compId]
				const deleted = []
				Object.keys(this.state.swgItemObj).forEach((k => {
					deleted.push(this.state.swgItemObj[k])
				}))
				this.setState({listItems: deleted})
		}
		this.setScrollable()
	}

	setScrollable() {
		const sa = document.getElementById('swg-scroll-area')
		const ca = document.getElementById('swg-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+60) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const view = <div id="site-working-group">
			<div id="swg-scroll-area"><div id="swg-client-area">
				<div className="title-bar">SITE WORKING GROUP</div>
				<div id="swg-cell1">
					<table className="swg-table-header">
						<col style={{width: '20%'}} />
						<col style={{width: '20%'}} />
						<col style={{width: '20%'}} />
						<col style={{width: '20%'}} />
						<col style={{width: '10%'}} />
						<col style={{width: '10%'}} />
						<tr>
							<th>Registration Number</th>
							<th>First Name</th>
							<th>Middle Name</th>
							<th>Last Name</th>
							<th>Ext</th>
							<th>Sex</th>
						</tr>
					</table>
					{this.state.listItems}
				</div>
			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				showSubmit={true} disabled={this.state.disabled} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer">
				<OrgFooter submit={this.onSubmit} disabled={this.state.disabled} showSubmit={true} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => { this.setState({showInfoMessage: false}) }} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class ListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			ext: "-- SELECT --",
			sex: "-- SELECT --",
			member: {},
			disabled: props.disabled
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		this.getMemberDetails = this.getMemberDetails.bind(this)
	}

	componentWillMount() {
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken)
		ext.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name})
			}
			this.setState({extName: c})
		})
		const sex = APIGenericRequest.getAllSex(this.state.accessToken);
		sex.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.sex_id, name: v.name});
			}
			this.setState({sc: c});
		})
	}

	componentDidMount() {
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken)
		ext.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			c.push({id: -1, name: "N/A"})
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name})
			}
			this.setState({extName: c})
		})
		if(this.props.data != null) {
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIconGray} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			if(!this.state.disabled) {
				var disabled = (this.props.data.registration_no != null)? true: false
			}
			else {
				disabled = true
				var disabledOrgDetail = true
			}
			this.setState({
				ext: (this.props.data.extension_name == null)? "N/A": this.props.data.extension_name,
				firstName: this.props.data.first_name,
				middleName: this.props.data.middle_name,
				lastName: this.props.data.last_name,
				regNum: this.props.data.registration_no,
				sex: (this.props.data.sex_code == "F")? "FEMALE": "MALE",
				organization: this.props.data.organization,
				position: this.props.data.position,
				disabled: disabled,
				disabledOrgDetail: disabledOrgDetail,
				member: {
					registration_no: this.props.data.registration_no,
					extension_name: this.props.data.extension_name,
					first_name: this.props.data.first_name,
					middle_name: this.props.data.middle_name,
					last_name: this.props.data.last_name,
					member_id: this.props.data.member_id,
					sex_code: this.props.data.sex_code
				},
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIconGray} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.member)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		const fn = this.state.member.first_name? this.state.member.first_name: ''
		const ln = this.state.member.last_name? this.state.member.last_name: ''
		const name = `${fn} ${ln}`
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove member ${name}?`
		})
	}


	getMemberDetails(regNum) {
		const apiCall = APIFarmerRequest.getFarmerDetailsByRegistrationNumber(this.state.accessToken, regNum)
		apiCall.then((response) => {
			if(response.status === "SUCCESS") {
				const apiCall = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken, response.results.farmer_id)
				apiCall.then((res) => {
					if(res.status === "SUCCESS") {
						this.state.member["registration_no"] = regNum
						this.state.member["first_name"] = res.results.farmerBasicInfo.first_name
						this.state.member["middle_name"] = res.results.farmerBasicInfo.middle_name
						this.state.member["last_name"] = res.results.farmerBasicInfo.last_name
						this.state.member["extension_name"] = res.results.farmerBasicInfo.extension_name
						this.state.member["sex_code"] = res.results.farmerBasicInfo.sex_code
						this.props.handler("member", this.state.itemId, null, this.state.member)
						this.setState({
							firstName: res.results.farmerBasicInfo.first_name,
							middleName: res.results.farmerBasicInfo.middle_name,
							lastName: res.results.farmerBasicInfo.last_name,
							ext: (res.results.farmerBasicInfo.extension_name == null)? "N/A": res.results.farmerBasicInfo.extension_name,
							sex: (res.results.farmerBasicInfo.sex_code == "F")? "FEMALE": "MALE",
							disabled: true
						})
					}
				})
			}
			else {
				this.setState({
					firstName: null,
					middleName: null,
					lastName: null,
					ext: "-- SELECT --",
					sex: "-- SELECT --",
					disabled: false
				})
			}
		})
	}

	render() {
		const view = <div className="swg-member">
			<div>
			<div>{this.state.addDeleteButton}</div>
			<table className="swg-table-data">
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '10%'}} />
				<col style={{width: '10%'}} />
				<tr>
					<td>
						<InputSearchWidget cStyle={{'width': '100%'}} isNumeric={true}
							onSearchClick={(value) => {
								if(value == null || value === "") {
									return
								}
								this.getMemberDetails(value)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}}
							onEnterPress={(value) => {
								this.getMemberDetails(value)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}}
							value={this.state.regNum}
							disabled={this.state.disabled}
						/>
					</td>
					<td>
						<input className="swg-firstname" type="text" value={this.state.firstName} onChange={(e) =>{
							this.state.member["first_name"] = e.target.value
							this.props.handler("member", this.state.itemId, null, this.state.member)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({firstName: e.target.value})
						}} disabled={this.state.disabled} />
					</td>
					<td>
						<input className="swg-middlename" type="text" value={this.state.middleName} onChange={(e) =>{
							this.state.member["middle_name"] = e.target.value
							this.props.handler("member", this.state.itemId, null, this.state.member)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({middleName: e.target.value})
						}} disabled={this.state.disabled} />
					</td>
					<td>
						<input className="swg-lastname" type="text" value={this.state.lastName} onChange={(e) =>{
							this.state.member["last_name"] = e.target.value
							this.props.handler("member", this.state.itemId, null, this.state.member)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({lastName: e.target.value})
						}} disabled={this.state.disabled} />
					</td>
					<td>
						<DropdownWidget list={this.state.extName} placeholder={this.state.ext} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								const ext = (id == -1)? null: val
								this.state.member["extension_name"] = ext
								this.props.handler("member", this.state.itemId, null, this.state.member)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
					</td>
					<td>
						<DropdownWidget list={this.state.sc} placeholder={this.state.sex}
							cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
								this.state.member["sex_code"] = (id == 1)? 'M': 'F'
								this.props.handler("member", this.state.itemId, null, this.state.member)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
					</td>
				</tr>
			</table>
			</div>
			<div style={{width:'50%', 'margin-left': '20px'}}>
				<table className="lst-table-data">
					<col style={{width: '40%'}} />
					<col style={{width: '40%'}} />
					<col style={{width: '20%'}} />
					<tr>
						<th>Name of Organization</th>
						<th>Position</th>
					</tr>
					<td>
						<input className="lst-orgname" type="text" value={this.state.organization} onChange={(e) =>{
							this.state.member["organization"] = e.target.value
							this.props.handler("member", this.state.itemId, null, this.state.member)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({orgName: e.target.value})
						}} disabled={this.state.disabledOrgDetail} />
					</td>
					<td>
						<input className="lst-position" type="text" value={this.state.position} onChange={(e) =>{
							this.state.member["position"] = e.target.value
							this.props.handler("member", this.state.itemId, null, this.state.member)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({position: e.target.value})
						}} disabled={this.state.disabledOrgDetail} />
					</td>
				</table>
			</div>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.props.handler("delete", this.state.itemId, null, this.state.member)
				}
			}} />}

		</div>
		return(view)
	}
}

const teams = [
	{id: 0, name: "MST"},
	{id: 1, name: "SST"}
]

export default SiteWorkingGroup
